import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

// Checa só se existe ao menos 1 conta cadastrada (contas_bancarias.select é
// permitido pela própria policy RLS, mesmo os campos *_enc sendo ilegíveis sem
// a chave — só usamos a contagem, nunca o conteúdo).
export function useTemContaBancaria(enabled: boolean, userId?: string) {
    const [temConta, setTemConta] = useState<boolean | null>(null);

    useEffect(() => {
        if (!enabled || !userId) return;
        supabase
            .from('contas_bancarias')
            .select('id', { count: 'exact', head: true })
            .eq('user_id', userId)
            .then(({ count }) => setTemConta(!!count && count > 0));
    }, [enabled, userId]);

    return temConta;
}